import React from 'react';
import { History } from 'history';
import { Form, Text } from '../../components';
import Model from './user-model';  //editable..s

interface IProps { 
    history: History;
    caption?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserAuthSignout extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onClick = () => {
        Model.removeUser();
        this.props.history.replace('/');
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <Form history={this.props.history} caption={this.props.caption || Model.caption + ' Signout'} buttonCaption='Signout' buttonOnBottom onSubmit={this.onClick}>              
                <Text label='Are you sure to logout?' textAlign='left' bold color='text.secondary'/>
            </Form>
        );
    }     
     
}